import { useCityStore } from '@/store/city/city'

import { Mode } from '@/types/main'

/*
 * Middleware чтобы разграничивать города по своим доменам 1lvl (Например ufa.farfor.ru || minsk.farfor.com)
 */
export default defineNuxtRouteMiddleware(({ path }) => {
  try {
    const { $host } = useNuxtApp()
    const {
      cityInfo: { domain },
    } = useCityStore()
    const { MODE } = useRuntimeConfig().public

    const cityDomain = domain?.split('.') || ''
    const host = $host?.split('.')

    if (!host || !cityDomain || [Mode.DEVELOPMENT].includes(MODE as Mode)) {
      return
    }

    if (cityDomain[cityDomain.length - 1] === host[host.length - 1]) return

    return navigateTo(`https://${domain}${path}`, {
      external: true,
    })
  } catch (error) {
    const { $sentryCaptureException } = useNuxtApp()

    $sentryCaptureException(`DomainRedirect упал с ошибкой: ${error}`)
  }
})
